import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import CategoryForm from '@/components/v2/ecommerce/CategoryForm.vue';
import CategoryUpdateMixin from '@/helpers/vue_mixins/v2/ecommerce/CategoryUpdateMixin';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import EcommerceCategoryFullDetails from '@/components/v2/ecommerce/CategoryFullDetails';
import InquiryCategoryFullDetails from '@/components/v2/inquiry/CategoryFullDetails';
import { FileUploadInputModel } from '@/helpers/entities/models/FileUploadInputModel';
import { InquirySubCategoryInputModel } from '@/helpers/entities/models/InquirySubCategoryInputModel';
let TheCategoryManagerUpdate = class TheCategoryManagerUpdate extends mixins(CategoryUpdateMixin, OrangeThemeMixin) {
    buildInquiryFormData(category) {
        const data = {
            name: null,
            description: null,
            inquirySubcategories: [],
            subcategories: [],
            images: [],
        };
        if (category) {
            const { name, description, subcategories, photos } = category;
            const inquirySubcategories = subcategories.map((sc) => {
                return new InquirySubCategoryInputModel({
                    uuid: sc.uuid,
                    name: sc.name,
                    description: sc.description,
                });
            });
            const images = photos.map((photo) => new FileUploadInputModel(photo));
            return {
                name,
                description,
                inquirySubcategories,
                subcategories: [],
                images,
            };
        }
        return data;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], TheCategoryManagerUpdate.prototype, "inquiry", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TheCategoryManagerUpdate.prototype, "b2b", void 0);
TheCategoryManagerUpdate = __decorate([
    Component({
        components: {
            PageTitle,
            CategoryForm,
            EcommerceCategoryFullDetails,
            InquiryCategoryFullDetails,
        },
    })
], TheCategoryManagerUpdate);
export default TheCategoryManagerUpdate;
